module.exports = __webpack_public_path__ + "img/2015048.b46eee95.svg";